export default "__VITE_ASSET__PotRt0G8__"